export default __webpack_public_path__ + "static/media/2243.a4988df3.png";